import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import LeftMarginSection from 'components/leftMarginSection/leftMarginSection';
import { classNameWithModifiers } from 'helpers/utilities/utilities';
import 'helpers/types/option';
import './content.scss';
// ---- Types ----- //
export const Appearances = {
    white: 'white',
    grey: 'grey',
    highlight: 'highlight',
    feature: 'feature',
    dark: 'dark',
};
export const Sides = {
    right: 'right',
    left: 'left',
};
// ----- Render ----- //
function Content({ appearance, children, id, modifierClasses, innerBackground, image, needsHigherZindex, border, }) {
    return (_jsx("div", { id: id, className: classNameWithModifiers('component-content', [
            appearance,
            image ? 'overflow-hidden' : null,
            needsHigherZindex ? 'higher' : null,
            border === false ? 'no-border' : null,
            border === true ? 'force-border' : null,
            ...modifierClasses,
        ]), children: _jsx(LeftMarginSection, { children: _jsxs("div", { className: innerBackground
                    ? `component-content__content--${innerBackground}`
                    : 'component-content__content', children: [children, image && _jsx("div", { className: "component-content__image", children: image })] }) }) }));
}
Content.defaultProps = {
    appearance: 'white',
    id: null,
    image: null,
    modifierClasses: [],
    innerBackground: null,
    needsHigherZindex: false,
    border: null,
};
// ---- Children ----- //
/*
Adds a multiline divider between block children.
*/
export function Divider({ small }) {
    return (_jsx("div", { className: classNameWithModifiers('component-content__divider', [
            small ? 'small' : null,
        ]), children: _jsx("hr", { className: "component-content__divider__line" }) }));
}
Divider.defaultProps = {
    small: false,
};
/*
Cancels out the horizontal padding
Wrap full bleed children in this.
*/
export function Outset({ children }) {
    return _jsx("div", { className: "component-content__outset", children: children });
}
/*
A vertical block with max width
*/
export function NarrowContent({ children, }) {
    return _jsx("div", { className: "component-content__narrowContent", children: children });
}
/*
A css class that sets the background colour to match the block.
Use on children that need to match the background of the parent
*/
export const bgClassName = 'component-content-bg'; // ---- Exports ----- //
export default Content;
